import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * "Showing 1 to 20 of 156 pending" plus Previous / Page X of Y / Next.
 * Rendered nothing when the list is empty.
 */
export function Pagination({
  page, pageSize, total, noun = "pending", onPageChange,
}: {
  page: number;
  pageSize: number;
  total: number;
  noun?: string;
  onPageChange: (page: number) => void;
}) {
  if (total === 0) return null;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  const btn = "flex items-center gap-1 px-2.5 py-1 rounded-md border text-xs hover:bg-accent disabled:opacity-40 disabled:hover:bg-transparent";

  return (
    <div className="flex items-center justify-between gap-3 flex-wrap text-xs text-muted-foreground">
      <span>Showing {from} to {to} of {total} {noun}</span>
      {totalPages > 1 && (
        <div className="flex items-center gap-2">
          <button type="button" className={btn} disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
            <ChevronLeft className="h-3.5 w-3.5" /> Previous
          </button>
          <span>Page {page} of {totalPages}</span>
          <button type="button" className={btn} disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>
            Next <ChevronRight className="h-3.5 w-3.5" />
          </button>
        </div>
      )}
    </div>
  );
}
